import sendPointOfNeedAppEvent from "./sendPointOfNeedAppEvent";
import { defaultTenant, getTenantByAccessKey } from "../../AlmeTenantSelector/AlmeTenants";
import { getTenantName } from "../../AlmeUtilities/Alme-utils";
function checkForResponse(response) {
    let responseName = "";
    if (Array.isArray(response === null || response === void 0 ? void 0 : response.responseActions) && !!(response === null || response === void 0 ? void 0 : response.responseActions.length)) {
        responseName = response === null || response === void 0 ? void 0 : response.responseActions[response.responseActions.length - 1].Name;
    }
    return responseName === "SwitchAccountConfirmation";
}
function setPONTenant(state, appConfig, apiUtils, ponEnterpriseId) {
    if (ponEnterpriseId && state.currentEnterpriseId !== ponEnterpriseId) {
        const userMetaData = appConfig.main.userMetadata;
        userMetaData.platformInformation.forEach((element) => {
            if (element.enterpriseId === ponEnterpriseId && appConfig.setTenant) {
                const selectedAccesskey = getTenantName(element).value;
                appConfig === null || appConfig === void 0 ? void 0 : appConfig.setTenant(getTenantByAccessKey(selectedAccesskey) || defaultTenant);
                state.accessKey = selectedAccesskey;
                state.currentEnterpriseId = ponEnterpriseId;
            }
        });
    }
    return state;
}
export const processPointOfNeedHook = (almeState, setAlmeState, appConfig, apiUtils, isAppEventsSent, logger, props) => {
    const state = Object.assign(Object.assign({}, almeState), { launchParameter: "PointOfNeed", launchPointName: props.launchPointName });
    if (!almeState.isOpen) {
        state.isOpen = true;
        props.setChatStatus.openChat();
    }
    if (!isAppEventsSent.current) {
        const stateCollection = setPONTenant(state, appConfig, apiUtils, props.ponEnterpriseId);
        setAlmeState(Object.assign(Object.assign({}, state), { currentEnterpriseId: stateCollection.currentEnterpriseId, accessKey: stateCollection.accessKey }));
    }
    else {
        sendPointOfNeedAppEvent(apiUtils, state, props.ponEnterpriseId)
            .then((pointOfNeedResponse) => {
            if (pointOfNeedResponse && checkForResponse(pointOfNeedResponse)) {
                apiUtils.processSendAccountEligibilityResponse(pointOfNeedResponse);
                apiUtils.appendToHistory(pointOfNeedResponse);
            }
            else if (pointOfNeedResponse) {
                state.history.push(pointOfNeedResponse);
                state.lastEntryId = pointOfNeedResponse.extensionData.entryId;
                state.chatId = pointOfNeedResponse.extensionData.chatId;
                setAlmeState(Object.assign(Object.assign({}, state), { launchPointName: undefined, launchParameter: undefined, lastActivityTime: Date.now() }));
            }
        })
            .catch((error) => logger.error(error));
    }
};
